import Vue from "vue";
import VuetifyMoney from "vuetify-money";

Vue.use(VuetifyMoney);
